import { useQuery } from 'react-query'
import { TrafficRepository } from 'repository/traffic'

export const useTrafficData = (coordinates?: number[], options?: any) => {
  return useQuery(
    coordinates && ['traffic-data', { coordinates }],
    () => TrafficRepository.fetch(coordinates!),
    options,
  )
}
